import React from "react";
import { Popover } from "react-bootstrap";
import Button from "../../Button";
import { Header } from "../styles";

const TmPopoverHeader = ({ children, showCloseButton, onClick }) => (
	<Popover.Header>
		<Header>
			{children}
			{showCloseButton && <Button btnType="icon" icons={"MdClose"} onClick={onClick}></Button>}
		</Header>
	</Popover.Header>
);

export default TmPopoverHeader;
